export const transformImage = (
  imageURL: string,
  option: { width?: number; height?: number } = {}
) => {
  // Error handling: Check if any required information is missing
  if (!imageURL || Object.keys(option).length === 0)
    return "/assets/pon-logo.svg";

  // Parse the URL using a URL constructor
  try {
    const match = /.com(\/.+)/.exec(imageURL);

    return `https://img2.storyblok.com/${option.width ?? 0}x${
      option.height ?? 0
    }/smart${match![1]}`;
  } catch {
    // Return a default image URL
    return "/assets/pon-logo.svg";
  }
};

interface ImageData {
  filename: string;
  focus?: string;
}

export const buildBannerImageUrl = (
  image: ImageData | undefined,
  isMobile: boolean,
  bannerHeight: number = 320,
  desktopScreenWidth: number = 1440
): string | undefined => {
  if (!image?.filename) return undefined;

  const size = `${isMobile ? bannerHeight : desktopScreenWidth}x${bannerHeight}`;

  if (image.focus) {
    return `${image.filename}/m/${size}/filters:focal(${image.focus})`;
  }

  return `${image.filename}/m/${size}`;
};